import React, { useState, useEffect } from "react";
import axios from "axios";

export default function DetailProjectModal({ onClose, project, clients }) {
    const cliente = clients?.find(c => c.id === project.id_cliente);
    const [arquivos, setArquivos] = useState([]);

    const formatarParaBRL = (valor) => {
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(valor);
    };

    const formatarData = (data) => {
        return new Date(data).toLocaleDateString("pt-BR");
    };

    const capitalize = (str) => {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    useEffect(() => {
        fetchArquivos();
    }, []);

    const fetchArquivos = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/pdfs/list/${project.id}`);

            if (res.data.arquivos && Array.isArray(res.data.arquivos)) {
                setArquivos(res.data.arquivos);
            } else {
                setArquivos([]); // Não há arquivos
            }
        } catch (err) {
            console.error("Erro ao buscar arquivos:", err);
            setArquivos([]);
        }
    };


    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file); // O backend espera "pdf"

        try {
            await axios.post(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/pdfs/upload/${project.id}`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            fetchArquivos();
        } catch (err) {
            console.error("Erro ao fazer upload:", err);
        }
    };

    const handleDownload = async (filename) => {
        window.open(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/pdfs/download/${project.id}/${filename}`, "_blank");
    };

    const handleDelete = async (filename) => {
        if (!window.confirm("Tem certeza que deseja excluir este arquivo?")) return;
        try {
            await axios.delete(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/pdfs/delete/${project.id}/${filename}`);
            fetchArquivos();
        } catch (err) {
            console.error("Erro ao deletar:", err);
        }
    };

    return (
        <div className="fixed inset-0 flex justify-center items-center bg-black/70 backdrop-blur-md z-50 p-4">
            <div className="glass-panel p-8 w-full max-w-4xl bg-slate-900/90 shadow-2xl border-white/10 relative overflow-y-auto max-h-[90vh]">
                <div className="text-center mb-8">
                    <h2 className="text-2xl font-bold text-white">
                        Projeto - {cliente ? cliente.nome : "Cliente não identificado"}
                    </h2>
                </div>

                <hr className="border-t border-white/10 my-6" />

                <h5 className="text-xl font-semibold text-gray-200 mt-6">Informações do Projeto</h5>
                <div className="mb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
                    <div>
                        <label className="block text-sm text-gray-500">Código</label>
                        <p className="text-gray-200">{project.id}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Valor</label>
                        <p className="text-gray-200">{formatarParaBRL(project.valor)}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Status</label>
                        <p className="text-gray-200">{capitalize(project.status)}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Cliente</label>
                        <p className="text-gray-200">{cliente ? cliente.nome : 'Não encontrado'}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Data de Início</label>
                        <p className="text-gray-200">{formatarData(project.data_inicio)}</p>
                    </div>
                    <div>
                        <label className="block text-sm text-gray-500">Data de Término</label>
                        <p className="text-gray-200">{formatarData(project.data_termino)}</p>
                    </div>
                </div>

                {project.descricao && (
                    <>
                        <h5 className="text-xl font-semibold text-gray-200 mt-10">Descrição</h5>
                        <div className="mb-6">
                            <p className="text-gray-200">{project.descricao}</p>
                        </div>
                    </>
                )}

                <hr className="border-t border-white/10 my-6" />

                <h5 className="text-xl font-semibold text-gray-200 mt-8">Documentos</h5>
                <div className="mt-2 mb-4">
                    <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleFileUpload}
                        className="glass-input w-full p-2"
                    />
                </div>

                {arquivos.length > 0 && (
                    <ul className="space-y-2">
                        {arquivos.map((filename) => (
                            <li key={filename} className="flex justify-between items-center bg-white/5 border border-white/10 p-3 rounded-xl mb-2">
                                <span className="text-gray-200">{filename}</span>
                                <div className="flex space-x-3">
                                    <button
                                        onClick={() => handleDownload(filename)}
                                        className="text-blue-400 hover:text-blue-300 transition-colors"
                                    >
                                        Baixar
                                    </button>
                                    <button
                                        onClick={() => handleDelete(filename)}
                                        className="text-red-400 hover:text-red-300 transition-colors"
                                    >
                                        Excluir
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}

                <div className="flex justify-center mt-8">
                    <button
                        onClick={onClose}
                        className="glass-button bg-gray-600 hover:bg-gray-700 w-full sm:w-auto px-10"
                    >
                        Fechar
                    </button>
                </div>
            </div>
        </div>
    );
}
